import Folder from '../store/schema/Folder';
import getMailboxRootFolder from './getMailboxRootFolder';
import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from '../util/folderConstants';

/**
 * Primary mailbox root folder selector
 */
export default function getPrimaryMailboxRootFolder(): Folder {
    return getMailboxRootFolder(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID);
}
